import { ButtonWithLoader } from "@components/button_with_loader/button_with_loader";
import { CheckboxField, TextField } from "@components/fields";
import { FlashMessage } from "@components/flash_messages/flash_message";
import { useMutate } from "@hooks/use_mutate";
import * as types from "@root/types";
import { api } from "@services/api";
import { appRoutes } from "@services/app_routes";
import { Form, Formik } from "formik";
import React, { FC, useMemo } from "react";

const ArtistExclusionForm: FC = () => {
  const createExclusions = useMemo(() => {
    return (token: string) => (data: types.ArtistExclusionCreateRequest) => {
      return api.artistExclusions.create(data, token);
    };
  }, []);

  const initialValues = {
    caseInsensitive: true,
    name: "",
  };

  const {
    submitData: submit,
    loading,
    error: apiError,
    data,
  } = useMutate<
    types.ArtistExclusionCreateResponse,
    types.ArtistExclusionCreateRequest
  >(createExclusions);
  const { errors } = data ?? {};
  const handleSubmit = (values: types.ArtistExclusionInputValues) => {
    if (loading) {
      return;
    }
    submit(values).then((data) => {
      if (data?.success) {
        const currentUrl = new URL(window.location.href);
        currentUrl.pathname = appRoutes.admin.artistExclusions.index();

        window.location.replace(currentUrl);
      }
    });
  };

  const formatErrors = (errors: types.ApiModelError): string[] => {
    return Object.entries(errors).flatMap(([fieldName, errorWords]) => {
      return errorWords.map(
        (error) =>
          `${fieldName[0].toUpperCase() + fieldName.slice(1)} ${error}`,
      );
    });
  };

  return (
    <>
      {errors ? (
        <FlashMessage message={formatErrors(errors)} type="error" />
      ) : null}
      {apiError ? (
        <FlashMessage
          message="Something terrible has happened.  Please try again later."
          type="error"
        />
      ) : null}
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        id="content_block_form"
      >
        <Form>
          <TextField
            label="Name/pattern to match"
            name="name"
            required
            helpElement={
              <>
                Must be at least 4 characters. e.g. &quot;Anas&quot; will match{" "}
                <em>Anas</em>tasi and Ban<em>anas</em> if ignore case is true
              </>
            }
          />
          <CheckboxField name="caseInsensitive" label="Ignore case?" />
          <div className="admin-form-controls">
            <div className="admin-form-controls--button">
              <a role="button" href="/admin/exclusions" className="secondary">
                Cancel
              </a>
            </div>
            <div className="admin-form-controls--button">
              <ButtonWithLoader loading={loading} value="Submit" />
            </div>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export { ArtistExclusionForm };
